import { useEffect } from 'react'

const isRealControl = (target: EventTarget | null): boolean =>
  target instanceof Element &&
  target.closest('button, a, input, select, textarea') !== null

/**
 * On a passive screen (intro, sentencing, stats) any button skips the line
 * being narrated: Enter, Space, a click or a tap. Key auto-repeat is
 * ignored so holding OK cannot blast through a whole round, and clicks on
 * real controls (mute, links) are left to those controls.
 */
export const useSkipNarration = (skip: () => void) => {
  useEffect(() => {
    const onKeyDown = (event: KeyboardEvent) => {
      if (event.repeat) return
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault()
        skip()
      }
    }
    const onClick = (event: MouseEvent) => {
      if (isRealControl(event.target)) return
      skip()
    }
    document.addEventListener('keydown', onKeyDown)
    document.addEventListener('click', onClick)
    return () => {
      document.removeEventListener('keydown', onKeyDown)
      document.removeEventListener('click', onClick)
    }
  }, [skip])
}
